import config from '../../../config/config-default';
import { toggleButtons } from '../submit/submit';
import { initCard } from '../submit/card';

const updatePrice = (total) => {
	document.getElementById('charge').value = total.toFixed(2);
	document.getElementById('total').value = total.toFixed(2);
	document.getElementById('info-total').textContent = total.toFixed(2);
};

const calculatePrice = () => {
	const deliveryOption = document.getElementById('delivery-option');
	const paymentOption = document.getElementById('payment-option');
	const numberBinsBags = document.getElementById('number-bins-bags');

	const { paymentOptions } = window[config.globalScope];
	const charge =
		paymentOptions[deliveryOption.value] &&
		paymentOptions[deliveryOption.value][paymentOption.value]
			? paymentOptions[deliveryOption.value][paymentOption.value].amount
			: 0;
	const pickups =
		deliveryOption.value !== 'one-off' && paymentOption.value > 0
			? +paymentOption.value
			: 1;
	const binsBags = numberBinsBags.value > 0 ? +numberBinsBags.value : 1;

	updatePrice(charge * pickups * binsBags);
};

const initStep4 = () => {
	calculatePrice();

	const paymentMethods = document.querySelectorAll(
		'input[name="payment_method"]',
	);
	const directDepositInfo = document.getElementById('direct-deposit-info');
	const cardDetails = document.getElementById('card-details');

	paymentMethods.forEach((radio) =>
		radio.addEventListener('change', () => {
			directDepositInfo.style.display =
				radio.value === 'Direct Deposit' ? 'block' : 'none';
			cardDetails.style.display =
				radio.value === 'Credit Card' ? 'block' : 'none';
			if (radio.value === 'Credit Card') initCard();
			toggleButtons(false);
		}),
	);
};

export default initStep4;
